import React from 'react';
import classNames from 'classnames';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import { Footer } from '../../footer/Footer';

type HeaderShellClasses = {
  appBarSpacer: string;
  chartContainer: string;
  content: string;
  contentFullHeight: string;
  root: string;
  tableContainer: string;
  tableContainerFullHeight: string;
};

type HeaderShellProps = {
  appBar: React.ReactNode;
  children?: React.ReactNode;
  classes: HeaderShellClasses;
  fullHeightContent?: boolean;
  isHeaderVisible: boolean;
  menu: React.ReactNode;
  profileMenu: React.ReactNode;
};

export function HeaderShell({
  appBar,
  children,
  classes,
  fullHeightContent,
  isHeaderVisible,
  menu,
  profileMenu,
}: HeaderShellProps): JSX.Element {
  return (
    <div className={classes.root}>
      <CssBaseline />
      {appBar}
      {profileMenu}
      {menu}
      <div className="flex flex-col justify-between w-full h-screen">
        <main
          className={classNames(classes.content, fullHeightContent && classes.contentFullHeight)}
        >
          {isHeaderVisible && <div className={classes.appBarSpacer} />}
          <Typography component="div" className={classes.chartContainer}></Typography>
          <div
            className={classNames(
              classes.tableContainer,
              fullHeightContent && classes.tableContainerFullHeight
            )}
          >
            {children}
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
}
